import React from 'react';
import TextField from '@mui/material/TextField';

const DetailsForm = ({ competitionType, registrationDetails, setRegistrationDetails }) => {
    return (
        <React.Fragment>
            <div className='s4g-section'>
                <div className='s4g-player-form-input-100'>
                    {competitionType === 2 && <div className='s4g-control-25'>
                        <TextField sx={{ width: '100%;' }} id="s4g-email" label="E-post" required
                            value={registrationDetails.email} onChange={e => setRegistrationDetails({ ...registrationDetails, email: e.target.value })} />
                    </div>}
                    <div className='s4g-control-25'>
                        <TextField sx={{ width: '100%;' }} id="s4g-telephone" label="Telefonnummer" required={competitionType === 2}
                            value={registrationDetails.telephone} onChange={e => setRegistrationDetails({ ...registrationDetails, telephone: e.target.value })} />
                    </div>
                    {competitionType === 2 && <div className='s4g-control-25'>
                        <TextField sx={{ width: '100%;' }} id="s4g-postcode" label="Postnummer" required
                            value={registrationDetails.postCode} onChange={e => setRegistrationDetails({ ...registrationDetails, postCode: e.target.value })} />
                    </div>}
                    {competitionType === 2 && <div className='s4g-control-25'>
                        <TextField sx={{ width: '100%;' }} id="s4g-city" label="Ort" required
                            value={registrationDetails.city} onChange={e => setRegistrationDetails({ ...registrationDetails, city: e.target.value })} />
                    </div>}
                </div>
            </div>
            <div className='s4g-section'>
                <div className='s4g-player-form-input-100'>
                    <TextField fullWidth id="s4g-commet" label="Övriga önskemål"
                        value={registrationDetails.comment} onChange={e => setRegistrationDetails({ ...registrationDetails, comment: e.target.value })} multiline rows={4} />
                </div>
            </div>
        </React.Fragment>
    );
}

export default DetailsForm;
